// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"750":"6932463f","879":"49dcf402"}[chunkId] + ".chunk.js";
};